// OWNER: AREA-TEMPLATES (templates/*, partials/*). Components go in src/features/templates.
import { createFileRoute } from '@tanstack/react-router'
import {
  VersionHistory,
  type DiffField,
  type HistorySearch,
} from '@/features/templates/history/VersionHistory'

const str = (v: unknown) => (typeof v === 'string' && v ? v : undefined)

export const Route = createFileRoute('/templates/$templateId/versions')({
  staticData: { crumb: 'Versions' },
  validateSearch: (s: Record<string, unknown>): HistorySearch => ({
    from: str(s.from),
    to: str(s.to),
    field:
      s.field === 'body' || s.field === 'subject' || s.field === 'text'
        ? (s.field as DiffField)
        : undefined,
    view: str(s.view),
    locale: str(s.locale),
  }),
  component: TemplateVersionsPage,
})

function TemplateVersionsPage() {
  const { templateId } = Route.useParams()
  const search = Route.useSearch()
  return <VersionHistory templateId={templateId} search={search} />
}
